import {HalContext} from "@cm/hal"
import {assertNever} from "@cm/utils"
import {HalPainterImageCompositorRef, HalPainterPrimitiveRef} from "@cm/hal/hal-ref"

export type PainterType = "primitive" | "compositor"

// TODO currently shaders are piling up in the cache
export class PainterCacheHal {
    constructor(private halContext: HalContext) {}

    dispose() {
        for (const painter of this.primitiveCache.values()) {
            painter.release()
        }
        this.primitiveCache.clear()
        for (const painter of this.compositorCache.values()) {
            painter.release()
        }
        this.compositorCache.clear()
    }

    getOrCreatePainter(painterType: "primitive", code: string): HalPainterPrimitiveRef
    getOrCreatePainter(painterType: "compositor", code: string): HalPainterImageCompositorRef

    getOrCreatePainter(painterType: PainterType, code: string) {
        switch (painterType) {
            case "primitive": {
                let painter = this.primitiveCache.get(code)
                if (!painter) {
                    painter = this.halContext.createHalPainterPrimitive(code)
                    this.primitiveCache.set(code, painter)
                }
                painter.addRef()
                return painter
            }
            case "compositor": {
                let painter = this.compositorCache.get(code)
                if (!painter) {
                    painter = this.halContext.createHalPainterImageCompositor(code)
                    this.compositorCache.set(code, painter)
                }
                painter.addRef()
                return painter
            }
            default:
                assertNever(painterType)
        }
    }

    private readonly primitiveCache = new Map<string, HalPainterPrimitiveRef>()
    private readonly compositorCache = new Map<string, HalPainterImageCompositorRef>()
}
